module.exports = __webpack_public_path__ + "static/media/icon-toggle-on.af2432ef.svg";